import * as React from "react";
import { SearchIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * Tiny helper component to expose the DataGrid search (Ctrl/Cmd+F) as a toolbar button.
 * We keep the real search UI inside DataGridSearch.
 */
export function DataGridSearchButton({ table }) {
  const onClick = React.useCallback(() => {
    table?.options?.meta?.onSearchOpenChange?.(true);
  }, [table]);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="font-normal"
      onClick={onClick}
      aria-label="Search in table">
      <SearchIcon className="text-muted-foreground" />
      Search
    </Button>
  );
}
